/** CDN base for home banner / campaign hero images. */
export const bannerMaterialSrc =
  "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/banner";

/** How many newest campaigns appear on the home banner carousel. */
export const BANNER_DISPLAY_COUNT = 5;

/** Banner filename → URL slug (stem without extension). */
export function bannerFileToSlug(bannerFile: string): string {
  return bannerFile.replace(/\.[^.]+$/, "");
}
